module.exports = __webpack_public_path__ + "img/terc_terormonster.bf23314.png";